// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

export default class WebLayout extends WebComponent {

  constructor(props) {
    super(props);
    this.state = {
      menuAvailable: false,
    };
    this.handleTouchOnSubmenu = this.handleTouchOnSubmenu.bind(this);
    this.handleMouseEnterOnMenu = this.handleMouseEnterOnMenu.bind(this);
    this.handleMouseLeaveOnMenu = this.handleMouseLeaveOnMenu.bind(this);
    this.handleMouseEnterOnMenuItem = this.handleMouseEnterOnMenuItem.bind(this);
    this.handleMouseLeaveOnMenuItem = this.handleMouseLeaveOnMenuItem.bind(this);
  }

  didMount() {
    //check for touch devices
    function is_touch_enabled() {
      return ('ontouchstart' in window) ||
          (navigator.maxTouchPoints > 0) ||
          (navigator.msMaxTouchPoints > 0);
    }

    this.body = document.body;
    this.menu = document.querySelector('.header__menu');
    this.submenu = this.element.querySelectorAll('.submenu');
    this.submenuItem = document.querySelectorAll('.header__menu-list-item');
    this.submenuToggle = this.element.querySelectorAll('.header__menu-list > li > a');
    this.eshopMenu = document.querySelector('.header__eshop');
    this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    this.productDetail = document.querySelector('#productDetail');
    this.interval = null;

    if (this.menu) {
      this.menu.addEventListener('mouseenter', this.handleMouseEnterOnMenu, { passive: true });
      this.menu.addEventListener('mouseleave', this.handleMouseLeaveOnMenu, { passive: true });
    }

    this.submenuItem.forEach((item) => {
      item.addEventListener('mouseenter', this.handleMouseEnterOnMenuItem);
      item.addEventListener('mouseleave', this.handleMouseLeaveOnMenuItem);
    });

    if (this.submenu) {
      if (is_touch_enabled()) {
        // add class to body
        this.body.classList.add('touch-device');

        this.submenuToggle.forEach((item) => {
          // touch start on touch devices
          item.addEventListener('touchstart', this.handleTouchOnSubmenu, false);
        });
      }
    }
    // adding class when more than 7 items in menu
    if (this.menu && this.submenuToggle && this.submenuToggle.length > 6) {
      this.menu.classList.add('header__menu--small');
    }

    // handling shift of secondary column in product detail
    if (this.productDetail) {
      this.handleProductDetailShifts();

      window.addEventListener("resize", () => {
        this.handleProductDetailShifts();
      })
    }
  }

  handleTouchOnSubmenu(e) {
    const touchedItem = e.target;
    const touchedItemParent = touchedItem.parentElement;
    const touchClose = touchedItemParent.querySelector('.submenu__touch-close');

    this.body.classList.add('menu--on');

    // prevent default behaviour of link on menu touch
    if (this.viewportWidth >= 992) {
      if (e.cancelable) {
        e.preventDefault();
      }
    }

    if (touchedItemParent.classList.contains('active')) {
      touchedItem.click();
    } else {
      this.submenuItem.forEach((item) => {
        // touch start on touch devices
        item.classList.remove('active');
      });
      touchedItemParent.classList.add('active');

      if (touchClose) {
        touchClose.addEventListener('touchstart', function () {
          this.parentElement.parentElement.parentElement.classList.remove('active');
          document.body.classList.remove('menu--on');
        });
      }
    }
  }

  handleMouseEnterOnMenu() {
    this.timeout = setTimeout(() => {
      this.setState({
        menuAvailable: true,
      });
    }, 200);
  }

  handleMouseLeaveOnMenu() {
    this.setState({
      menuAvailable: false,
    });
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  handleMouseEnterOnMenuItem(e) {
    const item = e.target;
    const submenu = e.target.parentElement.querySelector('.submenu');

    if (submenu && this.viewportWidth >= 992) {
      this.interval = setInterval(() => {

        if (this.state.menuAvailable) {
          item.classList.add('active');
          this.body.classList.add('menu--on');
        }
      }, 100);
    }

    if (!submenu) {
      this.body.classList.remove('menu--on');
    }
  }

  handleMouseLeaveOnMenuItem(e) {
    const item = e.target;
    const submenu = e.target.parentElement.querySelector('.submenu');

    if (submenu && this.viewportWidth >= 992) {
      item.classList.remove('active');
      //this.webOverlay.classList.remove('menu--active');
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  update() {
    const {menuAvailable} = this.state;
    if(this.menu) {
      classNames(this.menu, {'header__menu--megamenu-on': menuAvailable});
    }
  }

  /**
   *  Handling shift of secondary column in product detail
   */
  handleProductDetailShifts() {
    const galleryContainer = this.productDetail.querySelector('#galleryContainer');
    const gallery = this.productDetail.querySelector('#gallery');
    const secondaryColumn = this.productDetail.querySelector('#secondaryColumn');

    if (!galleryContainer || !gallery || !secondaryColumn) {
      return;
    }

    galleryContainer.style.height = ""

    const secondaryColumnShift = galleryContainer.scrollHeight - gallery.scrollHeight;

    secondaryColumn.style.marginTop = `-${secondaryColumnShift}px`;
    galleryContainer.style.height = "fit-content"
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js